module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/178.a9720388.png";